// models/attributes.js
import { apiUrl } from '../constants/global';
import { getLoggedUser } from '../state/user';

const apiUrlV2 = apiUrl + 'v2/';
const user = getLoggedUser();

// ── Master Attributes CRUD ──

export async function getAttributes(q) {
  return fetch(apiUrlV2 + 'attributes' + (q ? '?' + q : ''), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

export async function getAttribute(id) {
  return fetch(apiUrlV2 + 'attributes/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

export async function createAttribute(payload) {
  return fetch(apiUrlV2 + 'attributes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
    body: JSON.stringify(payload),
  }).then((data) => data.json());
}

export async function updateAttribute(id, payload) {
  return fetch(apiUrlV2 + 'attributes/' + id, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
    body: JSON.stringify(payload),
  }).then((data) => data.json());
}

export async function deleteAttribute(id) {
  return fetch(apiUrlV2 + 'attributes/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

// ── Auction Attributes (link table) ──

export async function getAuctionAttributes(auctionId) {
  return fetch(apiUrlV2 + 'auctions/' + auctionId + '/attributes', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

export async function updateAuctionAttributes(payload) {
  return fetch(apiUrlV2 + 'auctions/' + payload.auction_id + '/attributes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
    body: JSON.stringify(payload),
  }).then((data) => data.json());
}